/*eslint-disable*/

import { Dispatch, SetStateAction, useRef, useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Grid } from "@mui/material";
import {
  Button,
  FormContainerControlled,
  Pencil01Icon,
  Typography,
} from "components";
import { FormController } from "components/FormController/FormController";
import UploadFileIDCardHookForm from "components/UploadFile/UploadFileIDCard.hookform";
import UploadFilePortraitHookForm from "components/UploadFile/UploadFilePortrait.hookform";
import UploadFileSignHookForm from "components/UploadFile/UploadFileSign.hookform";
import { Modal } from "pages/Components";
import { useForm } from "react-hook-form";
import SignatureCanvas from "react-signature-canvas";
import * as Yup from "yup";
import { AuthSignOTP } from "./AuthSignOTP";
import {
  numberRequired,
  objectRequired,
  phoneNationRequired,
  stringRequired,
} from "helpers/yup";

const TYPE_NAME = "contract";

interface Props {
  openSignModal: boolean;
  setOpenSignModal: Dispatch<SetStateAction<boolean>>;
  refetch: any;
  resetIframe: any;
  setResetIframe: any;
  isDraw?: boolean;
  isValidatedPhoneNumber: boolean;
  handleSubmitSign: (input: any) => void;
  handleSubmitRequestOtp: (input: string) => void;
  handleSubmitForm: (
    smsOtp: string,
    phoneNumber: string,
    base64: string
  ) => void;
  typeName: string;
}

export const EContractSignForm = (props: Props) => {
  const {
    openSignModal,
    setOpenSignModal,
    isDraw,
    isValidatedPhoneNumber,
    resetIframe,
    setResetIframe,
    refetch,
    handleSubmitSign,
    typeName,
    handleSubmitRequestOtp,
    handleSubmitForm,
  } = props;

  const FormSchema = Yup.object({
    imgBase64: stringRequired,
    idCard: objectRequired,
    ...(typeName.toLowerCase() !== TYPE_NAME
      ? {
          phoneNumber: phoneNationRequired,
          otp: numberRequired,
        }
      : {}),

    rearIdCard: numberRequired,
    portraitImg: numberRequired,
  });

  const signContract = useRef<any | null>(null);
  const [isSign, setIsSign] = useState(false);
  const [isVerifiedIdCard, setisVerifiedIdCard] = useState(false);

  const methods = useForm<any>({
    resolver: yupResolver(FormSchema),
  });

  const { watch, setValue, reset, trigger } = methods;

  const onSubmit = (input: any) => {
    handleSubmitSign(input);
    setIsSign(false);
    setisVerifiedIdCard(false);
    reset();
  };

  return (
    <Modal
      isDefault
      onClose={() => {
        reset();
        setOpenSignModal(false);
        setIsSign(false);
        setisVerifiedIdCard(false);
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "60%",
            maxWidth: "600px", // Set your width here
          },
        },
      }}
      open={openSignModal}
      body={
        <FormContainerControlled methods={methods} onSubmit={onSubmit}>
          {!isSign ? (
            <>
              <Typography type="TextLG" fontWeight={600}>
                Add Signature
              </Typography>
              <Grid container spacing="14px" marginTop="0">
                {isDraw ? (
                  <Grid item xs={12} lg={12}>
                    <FormController
                      name="imgBase64"
                      label="Manual draw signature"
                    >
                      {({ field: { onChange, onBlur, value, ref } }) => (
                        <Box border={1} borderRadius="12px">
                          <SignatureCanvas
                            ref={signContract}
                            penColor="black"
                            canvasProps={{
                              width: 500,
                              height: 200,
                              className: "sigCanvas",
                            }}
                          />
                        </Box>
                      )}
                    </FormController>
                  </Grid>
                ) : (
                  <Grid item xs={12} lg={12}>
                    <UploadFileSignHookForm
                      required
                      name="imgBase64"
                      label="Signature File"
                      fileType={["PNG", "JPG"]}
                    />
                  </Grid>
                )}
              </Grid>
              <Box sx={{ float: "right", marginTop: "20px" }}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setOpenSignModal(false);
                    reset();
                  }}
                  sx={{ marginRight: "8px" }}
                >
                  Cancel
                </Button>
                {isDraw ? (
                  <Button
                    variant="outlined"
                    sx={{ marginRight: "8px" }}
                    onClick={() => {
                      return signContract?.current?.clear();
                    }}
                  >
                    Clear
                  </Button>
                ) : null}
                <Button
                  startIcon={<Pencil01Icon />}
                  onClick={async () => {
                    if (isDraw) {
                      const dataImage = signContract?.current
                        ?.getTrimmedCanvas()
                        ?.toDataURL("image/png");
                      setValue("imgBase64", dataImage);
                      if (await trigger(["imgBase64"])) {
                        setIsSign(true);
                      }
                    } else if (await trigger(["imgBase64"])) {
                      const toBase64 = (file: Blob) =>
                        new Promise((resolve, reject) => {
                          const reader = new FileReader();
                          reader.readAsDataURL(file);
                          reader.onload = () => resolve(reader.result);
                          reader.onerror = reject;
                        });
                      const fileBase64 = await toBase64(
                        watch("imgBase64") as unknown as Blob
                      );
                      setValue("imgBase64", fileBase64 as string);
                      setIsSign(true);
                    }
                  }}
                >
                  Sign
                </Button>
              </Box>
            </>
          ) : (
            <>
              {typeName.toLowerCase() === TYPE_NAME ? (
                <>
                  <Typography type="TextLG" fontWeight={600}>
                    Xác thực
                  </Typography>
                  <>
                    {!isVerifiedIdCard ? (
                      <>
                        <Grid container spacing="14px" marginTop="0">
                          <Grid item xs={12} lg={12}>
                            <UploadFileIDCardHookForm
                              required
                              name="idCard"
                              label="CMTND/CCCD mặt trước"
                              fileType={["PNG", "JPG"]}
                              isFrontIdCard
                            />
                          </Grid>
                          <Grid item xs={12} lg={12}>
                            <UploadFileIDCardHookForm
                              required
                              name="rearIdCard"
                              label="CMTND/CCCD mặt sau"
                              fileType={["PNG", "JPG"]}
                              isFrontIdCard={false}
                            />
                          </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="end" marginTop={8}>
                          <Box>
                            <Button
                              onClick={() => {
                                if (watch("idCard") && watch("rearIdCard")) {
                                  setisVerifiedIdCard(true);
                                }
                              }}
                            >
                              Tiếp theo
                            </Button>
                          </Box>
                        </Box>
                      </>
                    ) : (
                      <>
                        <Grid container spacing="14px" marginTop="0">
                          <Grid item xs={12} lg={12}>
                            <UploadFilePortraitHookForm
                              required
                              name="portraitImg"
                              label="Ảnh chân dung"
                              fileType={["PNG", "JPG"]}
                              isFrontIdCard
                            />
                          </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="end" marginTop={8}>
                          <Box>
                            <Button type="submit">Hoàn thành</Button>
                          </Box>
                        </Box>
                      </>
                    )}
                  </>
                </>
              ) : (
                <AuthSignOTP
                  isValidatedPhoneNumber={isValidatedPhoneNumber}
                  handleSubmitForm={handleSubmitForm}
                  handleSubmitRequestOtp={handleSubmitRequestOtp}
                />
              )}
            </>
          )}
        </FormContainerControlled>
      }
    />
  );
};
